export const retailerdata = [
  {
    name: "Aakrit Furniture",
    concernPerson: "Mr. Yogesh Pahuja",
    phone: "9810126361",
    area: "West Delhi",
    state: "Delhi NCR",
    address: "C23 Mansarover Garden, Kirti Nagar, New Delhi 110015",
  },
  {
    name: "Arterio",
    concernPerson: "Mr. Revant Pahuja",
    phone: "9650066820",
    area: "West Delhi",
    state: "Delhi NCR",
    address: "9/56, Block 9, Kirit Nagar Industrial Area, New Delhi 110015",
  },
  {
    name: "Delhi Handloom",
    concernPerson: "Mr. Nitin Tyagi",
    phone: "9999905141",
    area: "West Delhi",
    state: "Delhi NCR",
    address: "WZ 290, G Block, Jail Road, New Delhi, Delhi 110058",
  },
  {
    name: "Goel Rubber",
    concernPerson: "Mr. Mohan Goel",
    phone: "9810234512",
    area: "West Delhi",
    state: "Delhi NCR",
    address: "J2/6C, Metro Pillar No 409, Rajouri Garden, New Delhi 110027",
  },
  {
    name: "Indesign",
    concernPerson: "Mr. Ashok Pahuja",
    phone: "8368485157",
    area: "West Delhi",
    state: "Delhi NCR",
    address: "Opp Fire Station, C-29A Mansarover Garden, New Delhi 110015",
  },
  {
    name: "Garg Mattress India Pvt Ltd",
    concernPerson: "Mr. Abhishek Garg",
    phone: "9873207474",
    area: "West Delhi",
    state: "Delhi NCR",
    address: "D - 155, Jail Road Block D, Fateh Nagar New Delhi 110018",
  },

  {
    name: "Studio 88",
    concernPerson: "Mr. Vyas Sambi",
    phone: "9811171989",
    area: "West Delhi",
    state: "Delhi NCR",
    address: "Block no 2, Plot no 88/2, WHS Kirti Nagar, New Delhi 110015",
  },
  {
    name: "Just Rugs",
    concernPerson: "Mr. Raj Gupta",
    phone: "9988951111",
    area: "South Delhi",
    state: "Delhi NCR",
    address:
      "Shop No 2, Mahander Singh Market, Opp. Metro Pillar no 123, MG Road Ghitorn, New Delhi 110030",
  },
  {
    name: "Leela Furnishing",
    concernPerson: "Mr. Rajesh Gupta",
    phone: "9810039350",
    area: "South Delhi",
    state: "Delhi NCR",
    address: "58 Ringh Road, Block O Lajpat Nagar IIIrd New Delhi 110024",
  },
  {
    name: "Shree Balaji Mattress",
    concernPerson: "Mr. Vijay Kumar",
    phone: "9643602180",
    area: "South Delhi",
    state: "Delhi NCR",
    address: "J40/A Center Market, Lajpat Nagar II, Delhi 110024",
  },
  {
    name: "My Home Style",
    concernPerson: "Mr. Sahil",
    phone: "9319040527",
    area: "South Delhi",
    state: "Delhi NCR",
    address:
      "60/4 Yusuf Sarai Main Market, Opp Gurudwara, Green Park, New Delhi 110057",
  },
  {
    name: "Mattress Store",
    // concernPerson: "",
    phone: "9639099630",
    area: "South Delhi",
    state: "Delhi NCR",
    address:
      "Shop No. 3, C-16, Masoodpur Main Market, Vasant Kunj, New Delhi - 110070",
  },
  {
    name: "The Handloom Emorium",
    concernPerson: "Mr. Mannu Mahajan",
    phone: "9818187654",
    area: "East Delhi",
    state: "Delhi NCR",
    address:
      "A 138 Vikas Marg, Opp Metro Pillar no 37, Shakarpur, Delhi 110092",
  },
  {
    name: "Handloom Cotage",
    concernPerson: "Mr. Ravi Jain",
    phone: "9818439224",
    area: "North Delhi",
    state: "Delhi NCR",
    address: "Jawal Heri Market, 43 Pachim Vihar Delhi 110063",
  },
  {
    name: "Surprise Furnising",
    concernPerson: "Mr. Ankit Mittal",
    phone: "9654813838",
    area: "North Delhi",
    state: "Delhi NCR",
    address:
      "A-6 A  Block, Near Deepali Chowk, Saraswati Vihar Pitam Pura Delhi 110034",
  },
  {
    name: "Maa Santoshi Handloom",
    concernPerson: "Mr. Pankaj Abotte",
    phone: "9818845679",
    area: "Noida",
    state: "Delhi NCR",
    address:
      "Furniture Market, D332, D Block Sector 10, Noida, Uttar Pradesh 201301",
  },
  {
    name: "Noida Handloom",
    concernPerson: "Mr. Rakesh Kalra",
    phone: "9810108541",
    area: "Noida",
    state: "Delhi NCR",
    address:
      "Sunheri Market, Atta Market, Near Metro Station Sec 18, Captain Vijyant Thapar Marg Sec 27, Noida, Uttar Pradesh 201301",
  },
  {
    name: "Riti Handloom",
    concernPerson: "Mr. Raju",
    phone: "9555790429",
    area: "Greater Noida",
    state: "Delhi NCR",
    address:
      "Shop no 9, Basement GM Mall, Jagat Farm Gama I, Greater Noida, UP 201308",
  },
  {
    name: "Basant Lok",
    concernPerson: "Mr. Aniruddh",
    phone: "9868581007",
    area: "Ghaziabad",
    state: "Delhi NCR",
    address: "B225, Gr Floor Sector 2, Vaishali, Ghaziabad. UP 201010",
  },
  {
    name: "Comfort Zone",
    concernPerson: "Mr. Adnan",
    phone: "9654558750",
    area: "Ghaziabad",
    state: "Delhi NCR",
    address: "567 Niti Khand, IIIrd Near Rail Vihar Indrapuram, Ghaziabad",
  },
  {
    name: "KSR Shopping Centre",
    concernPerson: "Mr Nitin",
    phone: "9212199672",
    area: "Ghaziabad",
    state: "Delhi NCR",
    address: "HIG No 18 Sec 4, Near Shopprix Mall Vaishali Ghazibad",
  },
  {
    name: "Garima Emporium",
    concernPerson: "Mr.V K Sethi",
    phone: "9599303991",
    area: "Ghaziabad",
    state: "Delhi NCR",
    address:
      "601/5, Ashirwad Hotel, Ambedkar Road, Bagh Bhathyari, Naya Ganj , Ghaziabad, UP 201001",
  },
  {
    name: "My Mattress Store",
    concernPerson: "Mr. Mohammad Imran",
    phone: "9927602021",
    area: "Ghaziabad",
    state: "Delhi NCR",
    address: "Shop No 84, Navyug Market, Naya Ganj, Ghazibad UP 201001",
  },
  {
    name: "Aggarwal Handloom Shop",
    concernPerson: "Mr. Hemant Aggarwal",
    phone: "9650955624",
    area: "Ghaziabad",
    state: "Delhi NCR",
    address:
      "441/4 Kala Patthar Road, Makanpur, Nyay Khand III, Indrapuram, Ghaziabad, Uttar Pradesh 201010",
  },
  {
    name: "DD Interiors",
    concernPerson: "Mr. Raju",
    phone: "9991036000",
    area: "Sonipat",
    state: "Delhi NCR",
    address: "ITI Chowk, Sonipat, Haryana",
  },
  {
    name: "Space Furniture",
    concernPerson: "Mr. Sachin",
    phone: "9050900058",
    area: "Karnal",
    state: "Delhi NCR",
    address: "Furniture Market, Dyal Singh Colony, Karnal, Haryana 132001",
  },

  {
    name: "DRAPES WORLD",
    address:
      "#339 / 1 A, Anantramaiah Woolen Facrory,\nCompound, Opp Satelite Busstand, Bapuji,\nNagar, Bengaluru - 560026",
    location: "Bengaluru",
    phone: "080 26749449",
    listedAs: "Premium",
    state: "Karnataka",
  },
  {
    name: "GALA CURTAIN WORLD",
    address:
      "No 125,3rd Floor,Gala Square,\nR.V.Road,V.V.Puram,Bangalore - 560004",
    location: "Bengaluru",
    phone: "080-41153436",
    listedAs: "Premium",
    state: "Karnataka",
  },
  {
    name: "MISHRI DRAPES N DECOR",
    address:
      "2085/5, New No. 5/1, 3rd Main, 9th Cross,\nRPC Layout, Vijayanagar, Bengaluru - 560040",
    location: "Bengaluru",
    phone: "080-40981920",
    listedAs: "Premium",
    state: "Karnataka",
  },
  {
    name: "DECOR WALLS FURNISHINGS",
    address:
      "No 117,Ground Floor, Sanjay Nagar Main Road,\nNext To Ashwath Nagar Bus Stop, Bangalore -560094",
    location: "Bengaluru",
    phone: "080-40937951",
    listedAs: "Premium",
    state: "Karnataka",
  },
  {
    name: "LONDON LINE FURNISHINGS",
    address:
      "# 652, Ramagondanahalli, Whitefiled,\nVarthur Main Road, Near Adarsh Palm Medows,\nBengaluru - 560066",
    location: "Bengaluru",
    phone: "91642 14333",
    listedAs: "Premium",
    state: "Karnataka",
  },
  {
    name: "MORADA BONITO DESIGN STUDIO",
    address:
      "#531 F Block 1st Floor 80 Th Feet Main Road\nSahakarnagar Bangalore 560092",
    location: "Bengaluru",
    phone: "9743110000",
    listedAs: "Premium",
    state: "Karnataka",
  },
  {
    name: "D & D ELITE FLOORING",
    address:
      "# 45, 1st Cross, 2nd Main, Telecom Layout,\nVijayanagara, Bengaluru - 560023",
    location: "Bengaluru",
    phone: "9880753270",
    listedAs: "Premium",
    state: "Karnataka",
  },
  {
    name: "CENTURA HOME DECOR",
    address: "# 559/1 15th Main A Block Sahakarnagar\nBangalore 560092",
    location: "Bengaluru",
    phone: "9845963600",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "K B TRADERS",
    address:
      "DECOR LINES, 1st Floor, Plot no. 3,\n2nd Cross , Datta Galli, Vadgoan, BELGAUM - 590005",
    location: "Belagavi",
    phone: "9739673109",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "THE ADORE INTERIOR",
    address: "NO.8, SURVEY NO.16/P, MALAGALA, NAGAGABAVI , BANGALORE - 560091",
    location: "Bengaluru",
    phone: "96204 69780",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "KING DRAPES FURNISHINGS",
    address:
      "Ram Thulsi Chambers M S Ramaiah Road,\nMathikere Bangalore 560054",
    location: "Bengaluru",
    phone: "080-23602029",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "KING DRAPES FURNISHINGS - COMMERCIAL STREET",
    address: "# 97, Dispensary Road. Bengaluru - 560001",
    location: "Bengaluru",
    phone: "9886919120",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "ANIL DRAPES",
    address:
      "# 40 1st Floor 2nd Main Road 1st Cross\nH Siddhaih Road Sudhamanagar Bangalore 560027",
    location: "Bengaluru",
    phone: "9886089026",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "THE FABRIC WORLD",
    address:
      "# 2063/1 16TH B CROSS NEAR DAIRY CROSS\nYELAHANKA NEW TOWN BANGALORE 560064",
    location: "Bengaluru",
    phone: "7676177303",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "SJ MARKETING",
    address:
      "2C, 202 2nd Cross, East of NGEF Layout,\nKasturi Nagara, Kalyana Nagara Post,\nBengaluru - 560043",
    location: "Bengaluru",
    phone: "98808 44108",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "VB FURNISHINGS",
    address:
      "# 131 Kereguddadahallim Chikkabanavara Post,\nNear Gangadhareshwara Kalyana Mantpa,\nBengaluru - 573112",
    location: "Bengaluru",
    phone: "9880846940",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "COMFORT N STYLE",
    address: "N0.10/5 shop 3 5th Cross.Malleshwarm.,\nBangalore 560003",
    location: "Bengaluru",
    phone: "080 23469199",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "DRAPES HOUSE",
    address: "# 1, HSN Building, Whitefield Main Road,\nBengaluru - 560066",
    location: "Bengaluru",
    phone: "9019223227",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "HANDLOOM WORLD",
    address:
      "#364/1 Sreenivasa Mansion 10 Th B Main Road,\nJayanagar 3 Rd Block Bangalore\n560011",
    location: "Bengaluru",
    phone: "8095610983",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "ROYAL TRADING CO",
    address: "#2 Narayana Reddy Complex,\nNew Tippasandra, Bengaluru - 560075",
    location: "Bengaluru",
    phone: "9845050155",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "KESARI INTERIOR",
    address: "M.G Road, Chikkamagaluru - 577101",
    location: "Chikkamagaluru",
    phone: "9964123994",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "Sri Gururaja Furniture",
    address: "Talanki Towers, Vasavi Complex, Chitradurga\n- 577501",
    location: "Chitradurga",
    phone: "9845352942",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "CITY FURNITURE",
    address: "CITY POINT COMPLEX BM.ROAD,\nHASSAN- 573201",
    location: "Hassan",
    phone: "8172260555",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "AAKRUTHI INTERIOR",
    address:
      "1st Floor, Shankarshan, Salmara,\nOpp: Bundimata Bus Stop, Karkala,\nUdupi Dist. Karnataka - 574104",
    location: "Karkala",
    phone: "9632108430",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "GOOD HOMES INCORPORATION",
    address:
      "Ground Floor , No 15-1-T45/5, Ipper Bendoor , Balmatta to Bendoorwell Road,\nMangalore - 575002",
    location: "Mangalore",
    phone: "81971 93065",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "M/S. ACABEL HOME CONCEPTS PRIVATE LIMITED",
    address:
      "Door No.5-101/4(1),Mahaveer Engineering Works,\nBallal Industrial Estate,Yeyyadi, Mangalore - 575008",
    location: "Mangalore",
    phone: "8242214568",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "Karnataka Eng Co.",
    address: "1st Cross, Garden Area, Nehru Road, Shimoga - 577201",
    location: "Shimoga",
    phone: "77606 65735",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "Galleria Mattress Studio",
    address: "Opp. Royal Garden, Kalsanka,Udupi-576102\nKarnataka - 576102",
    location: "Udupi",
    phone: "99642 80971",
    listedAs: "Shop In shop",
    state: "Karnataka",
  },
  {
    name: "New Preethi Agencies",
    address: "Brahmin Street, Ballari - 583101",
    area: "Ballari",
    state: "Karnataka",
    phone: "9902253529",
  },
  {
    name: "Ganesh Handlooms",
    address:
      "148/B , Basavana galli beside maratha co-op\nbank, Belgaum- 590002",
    area: "Belgaum",
    state: "Karnataka",
    phone: "9945868798",
  },
  {
    name: "K B TRADERS",
    address:
      "DECOR LINES, 1st Floor, Plot no. 3,\n2nd Cross , Datta Galli, Vadgoan, BELGAUM - 590005",
    area: "Belgaum",
    state: "Karnataka",
    phone: "9739673109",
  },
  {
    name: "DRAPES WORLD",
    address:
      "#339 / 1 A, Anantramaiah Woolen Facrory,\nCompound, Opp Satelite Busstand, Bapuji,\nNagar, Bengaluru - 560026",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080 26749449",
  },
  {
    name: "GALA CURTAIN WORLD",
    address:
      "No 125,3rd Floor,Gala Square,\nR.V.Road,V.V.Puram,Bangalore - 560004",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080-41153436",
  },
  {
    name: "MISHRI DRAPES N DECOR",
    address:
      "2085/5, New No. 5/1, 3rd Main, 9th Cross,\nRPC Layout, Vijayanagar, Bengaluru - 560040",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080-40981920",
  },
  {
    name: "DECORONS TRINITY",
    address:
      "No.147 , 1st Floor, RV Road., Next to Arihant\nCollege, Bangalore - 560 004",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080-40909090",
  },
  {
    name: "WELLBORN FLOORINGS PVT LTD",
    address:
      "No 1572 Service Road , H S R Ring Road, Sec 1\nNear Dominnoz Piza , Bangalore - 560102",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9845697150",
  },
  {
    name: "LONDON LINE FURNISHINGS",
    address:
      "# 652, Ramagondanahalli, Whitefiled,\nVarthur Main Road, Near Adarsh Palm Medows,\nBengaluru - 560066",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "91642 14333",
  },
  {
    name: "MORADA BONITO DESIGN STUDIO",
    address:
      "#531 F Block 1st Floor 80 Th Feet Main Road\nSahakarnagar Bangalore 560092",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9743110000",
  },
  {
    name: "CENTURA HOME DECOR",
    address: "# 559/1 15th Main A Block Sahakarnagar\nBangalore 560092",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9845963600",
  },
  {
    name: "THE ADORE INTERIOR",
    address: "NO.8, SURVEY NO.16/P, MALAGALA, NAGAGABAVI , BANGALORE - 560091",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "96204 69780",
  },
  {
    name: "KING DRAPES FURNISHINGS",
    address:
      "Ram Thulsi Chambers M S Ramaiah Road,\nMathikere Bangalore 560054",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080-23602029",
  },
  {
    name: "KING DRAPES FURNISHINGS - COMMERCIAL STREET",
    address: "# 97, Dispensary Road. Bengaluru - 560001",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9886919120",
  },
  {
    name: "ANIL DRAPES",
    address:
      "# 40 1st Floor 2nd Main Road 1st Cross\nH Siddhaih Road Sudhamanagar Bangalore 560027",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9886089026",
  },
  {
    name: "DECOR WALLS FURNISHINGS",
    address:
      "No 117,Ground Floor, Sanjay Nagar Main Road,\nNext To Ashwath Nagar Bus Stop, Bangalore -560094",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080-40937951",
  },
  {
    name: "THE FABRIC WORLD",
    address:
      "# 2063/1 16TH B CROSS NEAR DAIRY CROSS\nYELAHANKA NEW TOWN BANGALORE 560064",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "7676177303",
  },
  {
    name: "SJ MARKETING",
    address:
      "2C, 202 2nd Cross, East of NGEF Layout,\nKasturi Nagara, Kalyana Nagara Post,\nBengaluru - 560043",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "98808 44108",
  },
  {
    name: "VB FURNISHINGS",
    address:
      "# 131 Kereguddadahallim Chikkabanavara Post,\nNear Gangadhareshwara Kalyana Mantpa,\nBengaluru - 573112",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9880846940",
  },
  {
    name: "COMFORT N STYLE",
    address: "N0.10/5 shop 3 5th Cross.Malleshwarm.,\nBangalore 560003",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080 23469199",
  },
  {
    name: "SRI VAIBHAV FURNITURES",
    address:
      "#1416,/A, B.B.M. Complex, Below Reliance Fresh,\nVijayanagara, Bengaluru - 560040",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080-23104879",
  },
  {
    name: "DRAPES HOUSE",
    address: "# 1, HSN Building, Whitefield Main Road,\nBengaluru - 560066",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9019223227",
  },
  {
    name: "MAX FURNISHINGS",
    address:
      "# 22, 10th Main, 100ft Road, Near Taramind\nHotel, Banaswadi, Bengaluru - 560043",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080-82422268",
  },
  {
    name: "JMR FURNISHINGS",
    address:
      "Shalom Towers, 9998, 5th A Cross, HRBR Layout,\nOuter Ring Road, Banaswadi, Bengaluru- 560043",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "080-40935484",
  },
  {
    name: "MNS FURNITURE",
    address:
      "1st Floor, 11 and 12,Sri Thiruchi Swamiji\nRoad, Sri Jnanakshi Layout, Bengaluru\nUrben, Karnataka 560098",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9902367870",
  },
  {
    name: "KLP INTERIOR",
    address:
      "# 01, 280 ft Rampura Main Road,\nChannasandra, Horamavu Post, Bengaluru - 560043",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9845032619",
  },
  {
    name: "METRO HANDLOOM FURNISHINGS",
    address:
      "# 1334, S.R. Eligans, Ground Floor, 6th Main,\n60ft Road, D� Group Layout, Srigandada Kaval,\nBengaluru - 560091",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9740153986",
  },
  {
    name: "SHREE VINAY ENT",
    address: "Kethaganahalli Road, Opp: Post Office,\nbidadi - 562109",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9741011389",
  },
  {
    name: "SNS ENT",
    address:
      "#44 , Balaji Niliya 1st Cross, Munikondappa\nLayout, Behind Widia School Club Road ,\nNagasandra Post, Bangalore - 560073",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9845988954",
  },
  {
    name: "SRI NANJUNDESHWARA SWAMY FURNISHINGS",
    address:
      "12, 2nd Cross,19th Main, MEI Layout,\nBagalagunte, Bengaluru- 560073",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9902277408",
  },
  {
    name: "D & D ELITE FLOORING",
    address:
      "# 45, 1st Cross, 2nd Main, Telecom Layout,\nVijayanagara, Bengaluru - 560023",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9880753270",
  },
  {
    name: "HANDLOOM WORLD",
    address:
      "#364/1 Sreenivasa Mansion 10 Th B Main Road,\nJayanagar 3 Rd Block Bangalore\n560011",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "8095610983",
  },
  {
    name: "IDEAL MATTRESS & FURNISHINGS",
    address:
      "# 1, B.K Circle Bus Stop, Jambusavaridinne Main Rd,\nJP Nagar 8th Phase, Bengaluru - 76",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "7829208502",
  },
  {
    name: "ROYAL TRADING CO",
    address: "#2 Narayana Reddy Complex,\nNew Tippasandra, Bengaluru - 560075",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "9845050155",
  },
  {
    name: "Divine Interior Design",
    address:
      "No.708, Shop No 03, B Block , ACES Country\nRoad, Bangalore - 560068",
    area: "Bengaluru",
    state: "Karnataka",
    phone: "7829345766",
  },
  {
    name: "New Grand Furniture",
    address:
      "Shop no 5/6, S.V.E. Societies,Akka Mahadevi\nshopping complex, Opp gurunanak gete udgir\nroad, Bidar - 585401",
    area: "Bidar",
    state: "Karnataka",
    phone: "8904233303",
  },
  {
    name: "Jyoti Enterprises",
    address:
      "Bhoomi Heights/Gani Tower, Ashram Road,\nOpp: B.L.D.E.A�S Hospital, Vijayapura -\n586103",
    area: "Bijapura",
    state: "Karnataka",
    phone: "9916141534",
  },
  {
    name: "New Patil Furnitures",
    address: "Pragati towers , opp bus stand, Bilagi587116",
    area: "Bilagi",
    state: "Karnataka",
    phone: "9731606305",
  },
  {
    name: "BHARAT BEDDING CENTER & FURNITURES",
    address: "Behind I.C.I.C.I Bank, Pavagada Road,\nChallakere - 577522",
    area: "Challakere",
    state: "Karnataka",
    phone: "9482688655",
  },
  {
    name: "SREE YALLAMMADEVI ENTERPRISES",
    address: "# 10, Main Road, Chelur - 572117",
    area: "Chelur",
    state: "Karnataka",
    phone: "7090803206",
  },
  {
    name: "KESARI INTERIOR",
    address: "M.G Road, Chikkamagaluru - 577101",
    area: "Chikkamagaluru",
    state: "Karnataka",
    phone: "9964123994",
  },
  {
    name: "Sri Gururaja Furniture",
    address: "Talanki Towers, Vasavi Complex, Chitradurga\n- 577501",
    area: "Chitradurga",
    state: "Karnataka",
    phone: "9845352942",
  },
  {
    name: "Design Fantasy",
    address:
      "# 391/2, Maheshwara Complex, 8th Main,\nOpp: Banapur Mat Clinic, P.J Extension,\nDavanagere - 577002",
    area: "Davanagere",
    state: "Karnataka",
    phone: "9888355171",
  },
  {
    name: "Sri Vijaya Balaji Enterprises",
    address: "Shop no - 2 15 154, OSB Road, Gangavathi - 583227",
    area: "Gangavathi",
    state: "Karnataka",
    phone: "94805 60925",
  },
  {
    name: "N.S. FURNITURE",
    address: "GKP COMPLEX 1ST FLOOR, N H 206, GUBBI\nTOWN - 572216",
    area: "Gubbi",
    state: "Karnataka",
    phone: "9901449615",
  },
  {
    name: "CITY FURNITURE",
    address: "CITY POINT COMPLEX BM.ROAD,\nHASSAN- 573201",
    area: "Hassan",
    state: "Karnataka",
    phone: "8172260555",
  },
  {
    name: "AMBIKA TEXTILES",
    address: "Main Road, Hiriyur - 577598",
    area: "Hiriyur",
    state: "Karnataka",
    phone: "9480422824",
  },
  {
    name: "STAR FURNITURE & BEDDING HOUSE",
    address: "SRINIDHI COMPLEX, URBAN BANK ROAD\nHIRIYUR - 577598",
    area: "Hiriyur",
    state: "Karnataka",
    phone: "9945372540",
  },
  {
    name: "S.K.L.S. FURNITURES",
    address:
      "Janatha Complex, Near Bala Talkies, Hampi\nRoad, Hospet - 583 201",
    area: "Hospete",
    state: "Karnataka",
    phone: "9742470736",
  },
  {
    name: "AAKRUTHI INTERIOR",
    address:
      "1st Floor, Shankarshan, Salmara,\nOpp: Bundimata Bus Stop, Karkala,\nUdupi Dist. Karnataka - 574104",
    area: "Karkala",
    state: "Karnataka",
    phone: "9632108430",
  },
  {
    name: "HINDUSTAN BEDDING HOUSE - KYATHASANDRA",
    address:
      "Old Police Station Road, Kesarmadu Road,\nKyatasandra, Tumkur - 572104",
    area: "Kyatasandra",
    state: "Karnataka",
    phone: "9742800760",
  },
  {
    name: "GOOD HOMES INCORPORATION",
    address:
      "Ground Floor , No 15-1-T45/5, Ipper Bendoor , Balmatta to Bendoorwell Road,\nMangalore - 575002",
    area: "Mangalore",
    state: "Karnataka",
    phone: "81971 93065",
  },
  {
    name: "M/S. ACABEL HOME CONCEPTS PRIVATE LIMITED",
    address:
      "Door No.5-101/4(1),Mahaveer Engineering Works,\nBallal Industrial Estate,Yeyyadi, Mangalore - 575008",
    area: "Mangalore",
    state: "Karnataka",
    phone: "8242214568",
  },
  {
    name: "SRI CHAMUNDESHWARI ENT",
    address:
      "1437, Kabeer Road, Mandi Mohalla,\nMysuru (Mysore), Karnataka 570001",
    area: "Mysore",
    state: "Karnataka",
    phone: "99454 26080",
  },
  {
    name: "SRI RAJARAJESHWARI ENT",
    address: "BM ROAD , RAMANAGARA - 571511",
    area: "Ramanagara",
    state: "Karnataka",
    phone: "9036593001",
  },
  {
    name: "Karnataka Eng Co.",
    address: "1st Cross, Garden Area, Nehru Road, Shimoga - 577201",
    area: "Shimoga",
    state: "Karnataka",
    phone: "77606 65735",
  },
  {
    name: "MY FURNITURE WORLD",
    address:
      "Alman Complex, Next to Muslim Hostel,\nB.H. Road, Tumkur - 572103",
    area: "Tumkur",
    state: "Karnataka",
    phone: "9739353511",
  },
  {
    name: "Galleria Mattress Studio",
    address: "Opp. Royal Garden, Kalsanka,Udupi-576102\nKarnataka - 576102",
    area: "Udupi",
    state: "Karnataka",
    phone: "99642 80971",
  },

  {
    name: "BHARAT FURNISHINGS",
    address:
      "Sai Icon, Survey 84/10,Near,2,Baner road, Sakal Nagar, Aundh,Pune, 411007",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "PARESH MAKHANI",
    phone: "9225653536",
  },
  {
    name: "DALAN FURNISHINGS",
    address:
      "Shop No-5,6,G-Building,Sylvan Heights, Dp Road,Aundh, Pune,411007",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "SURENDRA CHAUDHRY",
    phone: "8308899784",
  },
  {
    name: "VAMA FURNISHING",
    address: "171,Baner Road, Pune, 411045",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "NIMA CHAUDHRY",
    phone: "9890315988",
  },
  {
    name: "PICKUP FURNISHING",
    address:
      "Shop NO-4, Pavitra Building,1/1A, Hill Side,5 Opp Baner Road,Pune, 411045",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "",
    phone: "",
  },
  {
    name: "BHAAVI FURNISHING",
    address:
      "Shop No-12, Vertical Alcinai, Opp Corinthians Club, MohammedWadi, Corinthians Club, MohammedWadi, Pune,411060",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "DEEPAK IYER",
    phone: "9028011600",
  },
  {
    name: "JUSTIN DECOR",
    address:
      "Porwal Road, DhanoriJakat naka Dream Max Building,Opp Agatya Hotel, Pune,411047",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "",
    phone: "8208475707",
  },
  {
    name: "DC FURNISHING",
    address:
      "693, Narayan Peth, Opp Huzurpaga school Laxmi Road,Near Strawberry Kids, Pune,411030",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "KHALEEL ASLAM",
    phone: "9579849209",
  },
  {
    name: "DESIGNER COLLECTION",
    address:
      "Shop No-101, 1st floor Shoppers Morbit, Vishrantwadi,Near Big Bazar,Pune,411015",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "ANIL WADHWANI",
    phone: "9890584258",
  },
  {
    name: "FLOOR&FURNISHINGS",
    address:
      "Ground Floor, Clock House,Creativity,Off Airport Road,Opp Golf Course, Yerwada, Pune,411006",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "BRAJESH KUMAR",
    phone: "9325024121",
  },
  {
    name: "PUNE DECOR",
    address:
      "Beside Vatsalya Hospital, Sainath Chowk Nr.Mundhava Bridge, Raghoba Patil, Kharadi, Pune, 411014",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "SAMADHAN WAKCHAURE",
    phone: "9765336163",
  },
  {
    name: "N AND B FURNITURE (THE MATTRESS STORE)",
    address:
      "Katraj Hadapsar Bypass Road, Yewale-wadi, Kondhwa Budruk,Pune,411060",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MOIZ MASALEWALA",
    phone: "7972250024",
  },
  {
    name: "PRIME FURNITURE",
    address: "19,NIBM Road,NIBM Undri Road,Undri, Pune, 411060",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MUSTAFA MASALEWALA",
    phone: "7620973686",
  },
  {
    name: "CURTAIN DECOR",
    address:
      "Nirvana Complex,Shop No-5&6,Near Amanora Township,Opp Pune Mundhwa Kharadi, Road, Magarpatta City, Hadapsar,Pune, 400601",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "SONU MEWARA",
    phone: "9823745828",
  },
  {
    name: "QBANA DESIGN PVT LTD",
    address:
      "A-10,Office No-7, Meera Nagar Garden Lane No-7, N Main Road,Koregaon Park, Pune,411001",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "SANDEEP SAHANI",
    phone: "9822064822",
  },
  {
    name: "YASH DESIGNER STUDIO",
    address:
      "Suyog Naukar,7 Loves Chauk,Shankar Sheth Road, Near Apsara Theater, Swargate,Pune,411037",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MR DHANRAJ",
    phone: "8055525065",
  },
  {
    name: "SIDHARTH FURNISHING",
    address:
      "Vedacharya Phatak Guruji Road, Perugate Sadashiv Peth, Pune, 411030",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MR SIDHARTH",
    phone: "9822603222",
  },
  {
    name: "THEMES FURNISHING",
    address: "141,MG Road,Camp,Pune,411030",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "PARESH MUTHA",
    phone: "9890299404",
  },
  {
    name: "PRIME FURNISHING",
    address:
      "40/25 Erandawana, Opp Ayurved Rasashala,Prime Corner Bhonde Colony, Erandawana, Pune, 411004",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "SAGAR PUGALIYA",
    phone: "9767963129",
  },
  {
    name: "ROONAK FURNISHING",
    address:
      "6, Indraprastha Park,Next to Amber Hall,  Near Desai Bandhu Stand, Karve Road, Kothrud, Pune, 411004",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MR SUMIT",
    phone: "9822013519",
  },
  {
    name: "PERSONA FURNISHING",
    address:
      "Shop No-2,Green Valley Road,Near Kedari Petrol Pump,Wanowrie,Pune,411040",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MR DEEPAK",
    phone: "9158855757",
  },
  {
    name: "SUDARSHAN FURNISHING",
    address:
      "1-396, Narayan Peth Umbrya Ganpati Cross Road, Off, Laxmi Road, Pune,411030",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "",
    phone: "",
  },
  {
    name: "SUDARSHAN FURNISHING",
    address: "90, MG Road, Opp ICICI Bank, Camp, Pune,411001",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MRS.SAHEEN",
    phone: "8379940057",
  },
  {
    name: "ALANKAR MANGAL DECOR",
    address:
      "157,Old Mumbai Pune Road,Ambedkar Statue Chowk,Opp KSB Pump LTD, Atma Nagar,Kharalwadi, Pimpri Colony, Pimpri Chinchwad, Pune,411048",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MRS DARSHAN",
    phone: "9960258434",
  },
  {
    name: "FURNISHO GALLERY",
    address:
      "Shop No-106&107, First Floor above PNG Jewellers, Next to Croma,Pimpri Colony, Pimpri Chinchwad,411018",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MRS SHUBHAM",
    phone: "9763878265",
  },
  {
    name: "KASHMIR FURNITURE",
    address: "Plot No-11&12,Ashish Plaza, Nigdi, Sector-27 A, Pune,411044",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "",
    phone: "9371096726",
  },
  {
    name: "M FLOORA FURNISHING",
    address:
      "Kohinoor Grandeur, Sr No78/1  to 5/3, Shop No-13 Mukai chowk, Aundh-Ravet BRTS Road,Kiwale Gaon,Haveli",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "",
    phone: "9545659244",
  },
  {
    name: "MOHITA FURNISHING",
    address:
      "Metro-9, Shop No-3 & 4,Opp Park Street, Kalewadi Phata,Rahatni, Pune, 411017",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "",
    phone: "9970422958",
  },
  {
    name: "NICE FURNISHING",
    address: "Dyanesh Park, New Sanghavi, Pimpri, Chinchwad, Pune, 411027",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "",
    phone: "7276093962",
  },
  {
    name: "MYSTICAL GARMENTS (IN STORE SHOPPING)",
    address: "Elphinston Road, Khadki, Pune,411003",
    state: "Maharashtra",
    area: "Pune",
    concernPerson: "MR SACHIN",
    phone: "9822456921",
  },
  {
    name: "PREM CHANDA",
    address: "Near Jain Market, Sadar Bazar, Raipur",
    state: "Chattisgarh",
    area: "Raipur",
    concernPerson: "MR PRAJAY",
    phone: "9826000031",
  },
  {
    name: "URBAN LIVING",
    address: "Mungeli Naka Chowk, Opp to Sanjay, Taran Pushkar, Bilaspur,C.G,",
    state: "Chattisgarh",
    area: "Bilaspur",
    concernPerson: "MR DHIRAJ",
    phone: "8085555570",
  },
  {
    name: "SANDEEP DECOR WORLD",
    address: "Near Deshbandhu School,Station Road, Raipur, 492001",
    state: "Chattisgarh",
    area: "Raipur",
    concernPerson: "MR SANDEEP",
    phone: "9827163475",
  },
  {
    name: "SANSKRITI DECOR",
    address: "Shop No-103-04, Mahalaxmi Cloth, Market, Pandri, Raipur",
    state: "Chattisgarh",
    area: "Raipur",
    concernPerson: "TOKESH RATHOD",
    phone: "8889966659",
  },
  {
    name: "CASA DREAM",
    address: "Beside Arch Flyover, Ring Road No-1, New Rajendra Nagar, Raipur",
    state: "Chattisgarh",
    area: "Raipur",
    concernPerson: "GAURAV KHETPAL",
    phone: "7566248000",
  },
  {
    name: "KAMAL FURNITURE",
    address: "Mohan Talkies Road, Jamnipali Kobra, Chhattisgarh",
    state: "Chattisgarh",
    area: "Jamnipali",
    concernPerson: "",
    phone: "9827928424",
  },
  {
    name: "RIDDHI CURTAIN",
    address: "Shivaji Road Bindu Chowk Kohlapur, 416001",
    state: "Maharashtra",
    area: "Kohlapur",
    concernPerson: "AASHISH WACHANI",
    phone: "9503961166",
  },
  {
    name: "HAPPY HOME",
    address: "597,E Ward, Jana Appt, 2nd Lane Shhapur, kolhapur,416001",
    state: "Maharashtra",
    area: "Kohlapur",
    concernPerson: "RAHUL SHIVLING KOLAR",
    phone: "9890277288",
  },
  {
    name: "BHARAT FURNISHING",
    address: "Mariaai Complex Shivaji Circle Satara, 415001",
    state: "Maharashtra",
    area: "Satara",
    concernPerson: "DEVEN JAGDISH UDANI",
    phone: "9762583949",
  },
  {
    name: "SAJ THE FURNITURE WORLD",
    address:
      "Get No-229, Nandlapur Pachwad Phata Near Bachpan School Pune bangalore, Highway Karad,415539",
    state: "Maharashtra",
    area: "Satara",
    concernPerson: "SHRIKANT BALASAHEB MAGAR",
    phone: "9766719000",
  },
  {
    name: "CHAITANYA CURTAIN",
    address: "52/53B Savitri Complex Mangalwar Peth, Karad,415110",
    state: "Maharashtra",
    area: "Satara",
    concernPerson: "DILIP RAMCHANDRA KALE",
    phone: "9764649397",
  },
  {
    name: "DECENT GADI KARKHANA",
    address:
      "Sankeshwar Road Shetkari Petrol Pampajaval Gadhinglaj  Dist Kolhapur, 416001",
    state: "Maharashtra",
    area: "Kohlapur",
    concernPerson: "SAMIR NADAF",
    phone: "9545786690",
  },
  {
    name: "BHOKRE FURNISHING MIRAJ",
    address: "Near City Police Station Miraj 416410",
    state: "Maharashtra",
    area: "Miraj",
    concernPerson: "SAHEED AHMAD",
    phone: "9860804666",
  },
  {
    name: "SARDA BROTHERS",
    address: "Mahavir Nagar, Near Jain Vasti, Old Vakhar Bhag, Sangli, 416416",
    state: "Maharashtra",
    area: "Sangli",
    concernPerson: "UMA SARDA",
    phone: "9403008028",
  },
  {
    name: "FURNITURE GALLERY",
    address: "S/2-7, CidadeCommercial Complex, Altogether Porvorim,Goa, 403521",
    state: "Goa",
    area: "Goa",
    concernPerson: "RAJ MAGALORE",
    phone: "9823125136",
  },
  {
    name: "ASHNA CUSHION COLLECTION",
    address: "Near Sai Krupa Hostels Military Camp. Road Merces,Goa",
    state: "Goa",
    area: "Goa",
    concernPerson: "ATIQUE SHAIKH",
    phone: "7709002870",
  },
  {
    name: "GOOD MORNING GOA",
    address:
      "Shop No-7,8 and 9,Remedios Plaza, Below St.Anna Bakery Upper Bazar Ponda, Goa,403401",
    state: "Goa",
    area: "Goa",
    concernPerson: "CHAMPAK SETH",
    phone: "7709771344",
  },
  {
    name: "ARUN PRABHAKAR DESAI",
    address: "Shop No-4 & 5, Amber apts Vishal Road, Madgaon,Goa,403601",
    state: "Goa",
    area: "Goa",
    concernPerson: "ARUN DESAI",
    phone: "9923922900",
  },
  {
    name: "GOLBA'S THE HOME STORE",
    address:
      "Shop No-5 & 6, Ground Floor, Magestic Mark, Opp Santosh Garage, Aquem  Margao,Goa,403601",
    state: "Goa",
    area: "Goa",
    concernPerson: "SWPANIL GHOLBA",
    phone: "9623278190",
  },
  {
    name: "RAMRAI GIRI KENI",
    address: "Near Gandhi Market, Opp Bank Of Baroda, Margao,Goa, 403601",
    state: "Goa",
    area: "Goa",
    concernPerson: "GOURISH KENI",
    phone: "9552561889",
  },
  {
    name: "K K HOME FURNISHING",
    address:
      "Shop No-4, Navelkar Uttam Darshan, Near Sai Baba Temple Kadamba Plateau, Old Goa Bypass, Goa,4033006",
    state: "Goa",
    area: "Goa",
    concernPerson: "MR KAMLESH",
    phone: "9665686421",
  },
  {
    name: "M.B TRADERS",
    address:
      "Shop No-19, Blue 2 Kurtarkar Landmark, Opp Clarin Petrol Pump, Gogal, Margao, Goa, 403601",
    state: "Goa",
    area: "Goa",
    concernPerson: "MR MAYANK",
    phone: "",
  },
  {
    name: "RADHATMA TRADERS",
    address:
      "Carelite Chappel, Opp Vrundavan, Hospital Paddem Kara'swaha Mahapusa, Goa, 403507",
    state: "Goa",
    area: "Goa",
    concernPerson: "MR PARESH",
    phone: "9923020225",
  },
  {
    name: "ARIHANT TRADERS",
    address:
      "18/19 Arind Commercial Complex, Behind SBI, Kasturba Market, Solapur, 413002",
    state: "Maharashtra",
    area: "Solapur",
    concernPerson: "MONISH PATNI",
    phone: "9422458887",
  },
  {
    name: "ARIHANT ENTERPRISES",
    address: "Shop No-7,Antrolikar Shopping Center, Solapur, 413005",
    state: "Maharashtra",
    area: "Solapur",
    concernPerson: "ANISH PATNI",
    phone: "9423589704",
  },
  {
    name: "LAXMI ENTERPRISES",
    address: "Near Maheshwari Attal Bhawan, West Mangalwar Peth,Solapur,413002",
    state: "Maharashtra",
    area: "Solapur",
    concernPerson: "SANTOSH MANTRI",
    phone: "9421066140",
  },
  {
    name: "SAIRAJ PLAYWOOD",
    address:
      "Shop N0-10 & 11, Nagar Parishad Vyapari Sankul, Usmanabad, 413506",
    state: "Maharashtra",
    area: "Osmanabad",
    concernPerson: "VIJAY BORKAR",
    phone: "8855070070",
  },
  {
    name: "INTERIO STUDIO",
    address: "Aadva Rasta, Barshi, 413401",
    state: "Maharashtra",
    area: "Solapur",
    concernPerson: "VIKRAM RAUT",
    phone: "7276747426",
  },
  {
    name: "SHAH HOME DECOR",
    address:
      "992/A/9 Opp Dr Dilip Phade Hospital, Sadubhau Chowk, Akluj, 413101",
    state: "Maharashtra",
    area: "Solapur",
    concernPerson: "GOURAV SHAHA",
    phone: "8888800878",
  },
  {
    name: "KULTURE FURNISHING",
    address: "Opp Surya Hardware, Lonkhand Galli, Latur,413512",
    state: "Maharashtra",
    area: "Latur",
    concernPerson: "RANJEET MUNDADA",
    phone: "9326520204",
  },
  {
    name: "MADHURI ENTERPRISES",
    address: "Shop No-18 & 21, Suraj Gold, Sarda Capital, Beed, 431112",
    state: "Maharashtra",
    area: "Beed",
    concernPerson: "ANAND MUNDADA",
    phone: "9923242350",
  },
  {
    name: "VISHAL GADI GHAR",
    address: "Nagar Naka Beed,431122",
    state: "Maharashtra",
    area: "Beed",
    concernPerson: "SAGAR KULKARNI",
    phone: "7387426668",
  },
  {
    name: "OM FURNISHING",
    address: "Shop No-06, Alibhai Tower, Shivanjinagar, Nanded,431602",
    state: "Maharashtra",
    area: "Nanded",
    concernPerson: "PRIYANKA CHALIKWAR",
    phone: "9860992888",
  },
  {
    name: "AJAY HOME DECOR",
    address:
      "Shop No-14, Apurva Plaza , Bhavsar Chowk, Malegaon Road, Nanded, 431605",
    state: "Maharashtra",
    area: "Nanded",
    concernPerson: "AJAY LALSARE",
    phone: "8379834914",
  },
  {
    name: "FOAM AND FABRIC",
    address: "Chabda Tower,OPP Kelkar Market, Jalgaon,425001",
    state: "Maharashtra",
    area: "Jalgaon",
    concernPerson: "",
    phone: "9860050000",
  },
  {
    name: "DAFFODILS",
    address:
      "Shreeniketan Sharanpur Trimbak Link Road,Opp St.Andrews Church, Sharanpur, Nasik,422002",
    state: "Maharashtra",
    area: "Nasik",
    concernPerson: "",
    phone: "9823023245",
  },
  {
    name: "OMKAR HOME FASHION",
    address:
      "G-7, Surya Shopping Center, Near HDFC, Atm, Jalna Road,Orange corner, Sangamner,422605",
    state: "Maharashtra",
    area: "Ahmednagar",
    concernPerson: "",
    phone: "9822312736",
  },
  {
    name: "SHEETAL HANDLOOM",
    address: "Sector-1, Town Center,Jalna Road, Cidco, Aurangabad,431003",
    state: "Maharashtra",
    area: "Aurangabad",
    concernPerson: "",
    phone: "9423028177",
  },
  {
    name: "DEEPCHAND FOAM & FABRIC",
    address: "Shop No-766,Gandhi Chowk, Bhusawal, 425201",
    state: "Maharashtra",
    area: "Jalgaon",
    concernPerson: "",
    phone: "9823475890",
  },
  {
    name: "SISODIYA HOME DECOR",
    address: "Satana Road, Near Mosam Pul Opp. Lodha Market, Malegaon,423203",
    state: "Maharashtra",
    area: "Nasik",
    concernPerson: "",
    phone: "9922548597",
  },
  {
    name: "VIMAL ALUMUNIUM GLASS",
    address: "S.No-239,Yeola Road,Kopargaon,423601",
    state: "Maharashtra",
    area: "Ahmednagar",
    concernPerson: "",
    phone: "9326602000",
  },
  {
    name: "SEEMA HANDLOOM HOUSE",
    address:
      "1422, Kholl Galli Corner, Parola Road, OPP Bafana House,Dhule-424001",
    state: "Maharashtra",
    area: "Dhule",
    concernPerson: "",
    phone: "9881013888",
  },
  {
    name: "SAMRUDDHI ENTERPRISES",
    address:
      "C-4,Ashok Vihar,Datta Mandir Road, Near RD Dhongade Office, Nasik Road, Nasik, 422101",
    state: "Maharashtra",
    area: "Nasik",
    concernPerson: "",
    phone: "7588176551",
  },

  {
    name: "SUSHMA DISTRIBUTORS",
    concernPerson: "",

    phone: "9955018855",
    area: "Ranchi",
    address: "Opp Yamaha Showroom, Khora Toli, N.H-33 , Kokar, Ranchi-834001",
    state: "Jharkhand",
  },
  {
    name: "VINTAGE DECORE",
    concernPerson: "",
    phone: "9798261055",
    area: "Ranchi",
    address: "Ranglal Jalan Road, Baralal Street, Upper Bazar Ranchi-834001",
    state: "Jharkhand",
  },

  {
    name: "Furniture Galaxy",
    concernPerson: "",
    phone: "9263868461, 8210708163",
    area: "Hazaribag",
    address:
      "Patratu Chowk, Patna-Ranchi Road NH-33 Near Yuvraj Palace, Hazaribagh, Jharkhand",
    state: "Jharkhand",
  },
  {
    name: "SHIVANI",
    phone: "9431593301",
    concernPerson: "",
    area: "Ranchi",
    address: "Opp Galaxia Mall, Ratu Road, Ranchi- 834005",
    state: "Jharkhand",
  },
  {
    name: "VED FURNISHING",
    phone: "8340188785",
    concernPerson: "",
    area: "Ranchi",
    address: "Shop No G-4, Roshpa Tower , Main Road, Ranchi-834001",
    state: "Jharkhand",
  },
  {
    name: "GANPATI FURNITURE",
    concernPerson: "",
    phone: "9102714700",
    area: "Ranchi",
    address:
      "Near Ram Krishna Mission Asram, Opp Tagore Hill, Morabadi, Ranchi- 834008",
    state: "Jharkhand",
  },
  {
    name: "HOME STUDIO",
    phone: "06517962173- 9311530008",
    concernPerson: "",
    area: "Ranchi",
    address: "Mitra Market , Din Bandhu Lane, Upper Bazar, Ranchi- 834001",
    state: "Jharkhand",
  },
  {
    name: "FURNITURE HUB",
    concernPerson: "",
    phone: "9431118806",
    area: "Ranchi",
    address:
      "1st Floor, Ganpati Complex, Opp. Sidhu Kanhu Park,Ranchi College Road, Ranchi-834008",
    state: "Jharkhand",
  },
  {
    name: "HOME DECORE",
    concernPerson: "",
    phone: "0651-3510620",
    area: "Ranchi",
    address: "Opp Durga Mandir, Ratu Road, Ranchi- 834001",
    state: "Jharkhand",
  },
  {
    name: "ROHATAGI HOME SHINE",
    phone: "8252264682",
    concernPerson: "",
    area: "Ranchi",
    address:
      "H.No-1/247,Near kartik Oraon Chowk, Harmu By-Pass Road, Ranchi- 834002",
    state: "Jharkhand",
  },
  {
    name: "SHREE FURNISHING",
    phone: "9430752375",
    concernPerson: "",
    area: "Ranchi",
    address: "Kunjlal Street, Near Gandhi Chowk, Upper Bazar, ranchi-01",
    state: "Jharkhand",
  },
  {
    name: "KING FURNITURE",
    phone: "9431352482",
    concernPerson: "",
    area: "Ranchi",
    address: "KUTCHERY Road , Ranchi-01",
    state: "Jharkhand",
  },
  {
    name: "SHOPERS MART",
    phone: "9631209209",
    concernPerson: "",
    area: "Ranchi",
    address: "Roshpa Towers, 2nd Floor, Main Road, Ranchi-834001",
    state: "Jharkhand",
  },
  {
    name: "JAIN TEXTILE AGENCY",
    phone: "9430733048",
    concernPerson: "",
    area: "Ranchi",
    address: "Trade Center, Mackey Road, Upper Bazaar, Ranchi-1",
    state: "Jharkhand",
  },
  {
    name: "SL DECOR",
    phone: "8877185089- 8877041887",
    concernPerson: "",
    area: "Ranchi",
    address: "Opp Agraswn Bhawan, Seva Sadan Road, Upper Bazar, Ranchi- 834001",
    state: "Jharkhand",
  },
  {
    name: "MANNU FURNISHING",
    phone: "9934104321",
    concernPerson: "",
    area: "Ranchi",
    address:
      "Satya Ganga Arcade, Shop no: LG-13, Near Sarjana Chowk, Lalji Hirji Road, Ranchi-834001",
    state: "Jharkhand",
  },
  {
    name: "NEXTRIZE FURNITURE",
    phone: "8210437103",
    area: "Ranchi",
    concernPerson: "",
    address:
      "Opp Pitambra Palace, Near Mahindra Tractor Showroom,Booty More, Ranchi-835217",
    state: "Jharkhand",
  },
  {
    name: "FURNITURE GALLERY",
    phone: "6200376360",
    concernPerson: "",
    area: "Ranchi",
    address: "NH-33, Beside Of Reliance Fresh, Booty More, Ranchi-835217",
    state: "Jharkhand",
  },
  {
    name: "FURNISCO",
    phone: "7209839939",
    concernPerson: "",
    area: "Ranchi",
    address: "Near Argora Chowk, Ranchi",
    state: "Jharkhand",
  },
  {
    name: "STANDER FURNITURE",
    phone: "9431160908",
    concernPerson: "",
    area: "Bokaro",
    address: "By Pass Road Chas, Opp Bank Of India , Bokaro-827013",
    state: "Jharkhand",
  },
  {
    name: "OM FURNITURE HOUSE",
    phone: "7004835852",
    concernPerson: "",
    area: "Bokaro",
    address: "By pass Road,Near Vaibhav Hotel Chas, Bokaro-827013",
    state: "Jharkhand",
  },
  {
    name: "FURNITURE WORLD",
    phone: "8002287177",
    concernPerson: "",
    area: "Bokaro",
    address: "HE-5 , City Center, Bokaro-827004",
    state: "Jharkhand",
  },
  {
    name: "BHALOTIA",
    phone: "9931307500",
    concernPerson: "",
    area: "Bokaro",
    address: "Bhalotia Gali,Chas ,Bokaro-827013",
    state: "Jharkhand",
  },
  {
    name: "YUGVANCE ENT",
    phone: "8102917151",
    concernPerson: "",
    area: "Dhanbad",
    address: "Chandni Market, Steelgate, Saraidhela, Dhanbad-828127",
    state: "Jharkhand",
  },
  {
    name: "THE SAWARN DECORE",
    phone: "7070600782",
    concernPerson: "",
    area: "Dhanbad",
    address: "Opp- Bekarbandh Lake, LC Road, Dhanbad-826001",
    state: "Jharkhand",
  },
  {
    name: "FURNISHING CENTER",
    phone: "9534171744",
    concernPerson: "",
    area: "Dhanbad",
    address: "20,Rathore Mansion, Bank More, Dhanbad.",
    state: "Jharkhand",
  },
  {
    name: "HI SOCIETY",
    phone: "7250966668",
    concernPerson: "",
    area: "Jamshedpur",
    address: "5/2, Jhanda Chowk, Sakchi, Jamshedpur-1",
    state: "Jharkhand",
  },
  {
    name: "SCENIC INTERIO",
    phone: "9431179510",
    concernPerson: "",
    area: "Jamshedpur",
    address:
      "Opp Sakchi Gurudwara, Beside Chhappan Bhog, sakchi , Jamshedpur-1",
    state: "Jharkhand",
  },
  {
    name: "S.P.SINHA & SONS",
    phone: "6572321088",
    concernPerson: "",
    area: "Jamshedpur",
    address: "Main Road,Bistupur, Jamshedpur-831001",
    state: "Jharkhand",
  },
  {
    name: "BICHHAWAN",
    phone: "9905770925",
    concernPerson: "",
    area: "Daltonganj",
    address:
      "Dharamshala Road, Below S.B.I Bazaar Branch, Opp City Style, Daltonganj- 822101",
    state: "Jharkhand",
  },
  {
    name: "BICHHAWAN",
    phone: "9905770925",
    area: "Garhwah",
    concernPerson: "",
    address:
      "Vidya City Mall, Near Reliance Trendes Chiniya Road, Garhwa- 822114",
    state: "Jharkhand",
  },
  {
    name: "RACHIT FURNITURE",
    phone: "9631611100",
    concernPerson: "",
    area: "Ramgarh",
    address: "Shree Complex(Near Bijulia Over Bridge),Ramghar Cantt-829122",
    state: "Jharkhand",
  },
  {
    name: "FURNITURE GHAR",
    phone: "8935909099",
    concernPerson: "",
    area: "Hazaribag",
    address: "Guru Govind Singh Road, Hazaribag-825301",
    state: "Jharkhand",
  },
  {
    name: "FURNITURE GALAXY",
    phone: "8210708163",
    concernPerson: "",
    area: "Hazaribag",
    address: "Mission Hospital Road Near Dikshith Gas Agency Hazaribag-825301",
    state: "Jharkhand",
  },
  {
    name: "BIRU FURNITURE",
    concernPerson: "",
    phone: "9431192789",
    area: "Koderma",
    address: "Block Road,Near SBIBank, Jhumri Telaiya, Koderma-825409",
    state: "Jharkhand",
  },
  {
    name: "NEW CHITRAWALI",
    phone: "8541865022",
    concernPerson: "",
    area: "Deoghar",
    address: "Near Bhagwan Talkies, Shailbala Roy Road, Deoghar-814112",
    state: "Jharkhand",
  },
  {
    name: "KOLKATA FURNITURE",
    concernPerson: "",
    phone: "8210872783",
    area: "Dumka",
    address: "Near Mini Cinema, Bhagalur Road, Dudhani, Dumka",
    state: "Jharkhand",
  },
  {
    name: "KESHARI FURNITURE",
    phone: "7909044043",
    concernPerson: "",
    area: "Giridih",
    address: "Makatpur Road, Giridih-815301",
    state: "Jharkhand",
  },
  {
    name: "BHARTI BAG & FOAM HOUSE",
    phone: "8789495933",
    concernPerson: "",
    area: "Simdega",
    address: "Prince Chowk, Simdega - 835223",
    state: "Jharkhand",
  },
  {
    name: "RD ENTERPRISES",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "nehru Shoppiung Complex, Near Novelty Mall, Amritsar",
    area: "Amritsar",
    concernPerson: "MANDEEP SINGH",
    phone: "9888818101",
    state: "Punjab",
  },
  {
    name: "MODERN RUBBER INDUSTRY",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Hall bazar, Near Telephone Exchange, Amritsar",
    area: "Amritsar",
    concernPerson: "SHINDA",
    phone: "9216513674",
    state: "Punjab",
  },
  {
    name: "THE FURNSHING STORE",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Opp NArinNiketan, Nakodar Road, jalandhar",
    area: "Jalandhar",
    concernPerson: "BHAVEYA SINGLA",
    phone: "8198811211",
    state: "Punjab",
  },
  {
    name: "MOGLA DECORE",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Sadar Bazar, Kapurthala",
    area: "Kapurthala",
    concernPerson: "VIKAS",
    phone: "9814144488",
    state: "Punjab",
  },
  {
    name: "RAM LAL & COM",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Near Aarti Chowk, Madhok Complex, Ludhiana",
    area: "Ludhiana",
    concernPerson: "MANOJ",
    phone: "9872400999",
    state: "Punjab",
  },
  {
    name: "KATARIA INDUATRY",
    dealerType: "DISTRIBUTOR",
    brand: "ECLIPSE",
    address: "Kataria Building, Near Ghantagahr, Faridkot",
    area: "Faridkot",
    concernPerson: "MADAN LAL",
    phone: "9216655508",
    state: "Punjab",
  },
  {
    name: "R MAHAJAN SALES CORPN",
    dealerType: "Dealer",
    brand: "ECLIPSE",
    address: "Near Novelty mall, Dalhousie road, Pathankot",
    area: "Pahtankot",
    concernPerson: "SURESH MAHAJAN",
    phone: "9876311155",
    state: "Punjab",
  },
  {
    name: "PARKASH REXINE STORE",
    dealerType: "SD",
    brand: "SLEEP SONIC",
    address: "Near Bus Stand, Rop nagar",
    area: "Ropar",
    concernPerson: "PARAMJIT SINGH",
    phone: "9855126168",
    state: "Punjab",
  },
  {
    name: "MUNISH ENTERPRISES",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "fautain Chowk, main Bazar, Sirhind",
    area: "Sirhind",
    concernPerson: "MUNISH KUMAR",
    phone: "9814968752",
    state: "Punjab",
  },
  {
    name: "KAMAL FURNITURE",
    dealerType: "SD",
    brand: "ECLIPSE",
    address: "Nabha Gate, patiala",
    area: "Patiala",
    concernPerson: "KAMAL GABA",
    phone: "9216402964",
    state: "Punjab",
  },
  {
    name: "DHINGRA COLL",
    dealerType: "SD",
    brand: "ECLIPSE",
    address: "main Bazar, tirupari, Patiala",
    area: "Patiala",
    concernPerson: "SURESH KUMAR",
    phone: "9041286145",
    state: "Punjab",
  },
  {
    name: "AHUJA FURNISHERS",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "main Bazar, Rajpura Town, Rajpura",
    area: "Rajpura",
    s: "PARMOD AHUJA",
    phone: "9814462269",
    state: "Punjab",
  },
  {
    name: "CLASSIC FURNITURE",
    dealerType: "SD",
    brand: "SLEEP SONIC",
    address: "Near Bus stand, Ropar Road, Morinda",
    area: "Morinda",
    concernPerson: "ANIL KUMAR",
    phone: "8534000018",
    state: "Punjab",
  },
  {
    name: "KEDAR NATH & SONS",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Chintpurni Road, Gegret",
    area: "Gengret",
    concernPerson: "DINESH",
    phone: "9418038840",
    state: "Punjab",
  },
  {
    name: "DESHMESH FURISHERS",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Opp Gate No 2, RCF kapurthla",
    area: "Kapurthala",
    concernPerson: "KULBIR SINGH",
    phone: "9988035356",
    state: "Punjab",
  },
  {
    name: "SHAH SONS",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Opp Kissan Bhawan, Sec 22 D, Chandigarh",
    area: "Chandigarh",
    concernPerson: "SUNIL SEKHRI",
    phone: "9316161718",
    state: "Punjab",
  },
  {
    name: "Ashok Aggarwal & CO.",
    // dealerType: "DD",
    brand: "ECLIPSE",
    address: "S.C.O. No. 4, (Back Side) Sec. 7-C, Madhya Marg, Chd.",
    area: "Chandigarh",
    // concernPerson: "SUNIL SEKHRI",
    phone: "9814509216",
    state: "Punjab",
  },
  {
    name: "MASTER & COM",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Punjabi Mohhalla, Near Civil Hospital, Ambala",
    area: "Ambala",
    concernPerson: "KAMAL GUPTA",
    phone: "9802469001",
    state: "Punjab",
  },
  {
    name: "CHAMAN LAL & SONS",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "Partap bazar, Near PNb bank, Moga",
    area: "Moga",
    concernPerson: "RAJ AHUJA",
    phone: "9417301104",
    state: "Punjab",
  },
  {
    name: "CHARAN SINGH & SONS",
    dealerType: "DD",
    brand: "ECLIPSE",
    address: "manin Bazar, Kanchi gate, Phagwara",
    area: "Phagwara",
    concernPerson: "GAGANDEEP",
    phone: "9915607623",
    state: "Punjab",
  },

  {
    name: "Shagun Interiors",
    address: "33/32, shipra path, mansarovar, Jaipur-302020",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "9413341262",
    email: "shagun.decor@yahoo.com",
  },
  {
    name: "Hansa Palace Art Furniture Pvt. Ltd.",
    address: "7 Hansa Palace Hiran, Magri Sector 4, Udaipur-313002",
    area: "Udaipur",
    state: "Rajasthan",
    phone: "9829041344",
    email: "hansapalace@gmail.com",
  },
  {
    name: "Chandiram",
    address: "jaipur road, Ajmer-305001",
    area: "Ajmer",
    state: "Rajasthan",
    phone: "9414008596",
    email: "jr.chandiram1957@gmail.com",
  },
  {
    name: "J. B. Khetawat & Sons",
    address: "Opp.-Union Bank, Naya Bazar, Ajmer-305001",
    area: "Ajmer",
    state: "Rajasthan",
    phone: "7014531191",
    email: "jbkhetawat1980@gmail.com",
  },
  {
    name: "The Drapery",
    address: "Gautam Marg, Gandhi Path, Jaipur",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "9166420794",
    email: "draperyjaipur@gmail.com",
  },
  {
    name: "Savya International",
    address: "A-19, Sahkar Marg, Jaipur-302001",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "9928684218",
    email: "order.drapesanddroops@gmail.com",
  },
  {
    name: "Sybaritic Linen",
    address:
      "37, Prithiviraj Nagar, Happy Tower Basement, Maharani Farm, Durgapura, Jaipur",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "9351972345",
    email: "sybariticlinen@gmail.com",
  },
  {
    name: "Gopal Store",
    address: "70, New Cloth Market, Kota- 324005",
    area: "Kota",
    state: "Rajasthan",
    phone: "982943077",
    email: "gopalstorekota@refiffmail.com",
  },
  {
    name: "Floor & Furnishing House",
    address: "271, New Atish Market, Jaipur-302020",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "9694400080",
    email: "neraj.jain.99@gmail.com",
  },
  {
    name: "Saubhagya Furnishing",
    address: "Shop-115, 127-128, JAI Complex Behind- Axix Bank, Alwar",
    area: "Alwar",
    state: "Rajasthan",
    phone: "8426809090",
    email: "saubhagyaalwar@rediffmail.com",
  },
  {
    name: "Kiran Enterprises",
    address: "755, Mishra Raja Ji Ka Rasta, Indra Bazar, Jaipur-302001",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "9314356084",
    email: "",
  },
  {
    name: "SRS Furnishers",
    address: "D-75, Shiv Heera Path, Chomu House, C-Sheme, Jaipur",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "8107954141",
    email: "srsfurnishers@yahoo.com",
  },
  {
    name: "K. D. Sales",
    address:
      "Plot No.-2, Rohini Nagar, Near ICICI Bank, 7no. Chauraha, Goner road, Jagatpura, Jaipur-302017",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "8003995763",
    email: "",
  },
  {
    name: "Interior Hub",
    address: "Opp.- Rikhabdas Ji Garage, Choutan Road, Barmer-344001",
    area: "Barmer",
    state: "Rajasthan",
    phone: "9950356590",
    email: "",
  },
  {
    name: "Fabric Q",
    address: "12-k-4, Jyoti Nagar, Opp. Harley Devidson Showroom, Jaipur-05",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "9571007296",
    email: "fabricqjaipur@gmail.com",
  },
  {
    name: "Rainbow Collection",
    address:
      "A29, Laxmi Nagar-A, Near Sanskriti Sports Academy, Parthsarthi Residency, Khejob Ka Bas, Mansarovar Extension, Jaipur-302020",
    area: "Jaipur",
    state: "Rajasthan",
    phone: "9024815177",
    email: "amit.mathur94@yahoo.com",
  },
  {
    name: "Goyal Trading company",
    address: "Savoke Road,Near LIC building ,Siliguri .pin-734001",
    phone: "9832301991",
    area: "Siliguri",
    state: "West Bengal",
  },
  {
    name: "Mahal furnishing",
    address: "Panitanki more, Siliguri ,pin-743001",
    phone: "9434068113",
    area: "Siliguri",
    state: "West Bengal",
  },
  {
    name: "Hindustan wood craft",
    address: "savoke road,2nd mile, siliguri,pin-734001",
    phone: "9332926522",
    area: "Siliguri",
    state: "West Bengal",
  },
  {
    name: "Furniture Junction",
    address: "Lemon Tree Hotel building,3rd mile, pin- 734002",
    phone: "9093211111",
    area: "Siliguri",
    state: "West Bengal",
  },
  {
    name: "Sleep studio",
    address: "Isckon Road,Near Payel cinema hall .siliguri, pin- 734001",
    phone: "7001875622",
    area: "Siliguri",
    state: "West Bengal",
  },
  {
    name: "Sharma Furniture",
    address: "Jalpaiguri,opposite LIC building, pin- 735002",
    phone: "9126015008",
    area: "Jalpaiguri",
    state: "West Bengal",
  },
  {
    name: "Sarkar steel",
    address: "Falakata,near BDO office road .pin-735211",
    phone: "9434131709",
    area: "Falakata",
    state: "West Bengal",
  },
  {
    name: "Vasundhara",
    address: "Malda, Kani more .pin-732101",
    phone: "9007027568",
    area: "Malda",
    state: "West Bengal",
  },
  {
    name: "kamala furnishing",
    address: "Hill cart road,Siliguri pin-734003",
    phone: "9593297712",
    area: "Siliguri",
    state: "West Bengal",
  },
  {
    name: "Fab furniture",
    address: "Jalpaiguri,near thana road pin-735001",
    phone: "8016163749",
    area: "Jalpaiguri",
    state: "West Bengal",
  },
  {
    name: "woodcon",
    address: "N S road,Jaigaon. pin-735182",
    phone: "9932231385",
    area: "Jaigaon",
    state: "West Bengal",
  },
  {
    name: "Mahakal furniture",
    address: "Namchi,Sikkim .pin-737126",
    phone: "9641530871",
    area: "Namchi",
    state: "Sikkim",
  },
  {
    name: "Duro furnishings",
    address: "Attingal",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Popular furniture",
    address: "Kazhakkoottam",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Royaloak Furniture (Thomson group)",
    address: "Kesavadasapuram",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Veracity Furniture",
    address: "Kannanmoola",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Olivia furniture",
    address: "Mannanthala",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Royal furnishings",
    address: "Vattiyurkavu",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Freezone Refrigeration",
    address: "Vattiyurkavu",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Fortune Furniture",
    address: "Killippalam",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Renjini furniture",
    address: "Thirumala",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Balamurali Beds",
    address: "Karamana",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Venma furniture",
    address: "kattakkada",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Bismi furniture & home appliances",
    address: "Nedumangad",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Royal furniture & home appliances",
    address: "Venjarammoodu",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Kochuvila home appliances",
    address: "kallara",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Royal agencies",
    address: "Poovachal",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "S R furniture",
    address: "kilimanoor",
    area: "Trivandrum",
    state: "Kerala",
  },
  {
    name: "Indoorpark",
    address: "Umayanalloor",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Oxford furniture",
    address: "Polayathodu",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Reshmi furnishing home (kool foam)",
    address: "Kollam",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Bed gallery (Thadathil enterprises)",
    address: "Kadappakkada",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Olive furniture",
    address: "kavanadu",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Kenza furniture",
    address: "karunagappally",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "K K furniture",
    address: "Kottarakkara",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Sreebhadra furniture",
    address: "Kottarakkara",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Kalluvilayil home appliances",
    address: "ayur",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "NVP hyper market",
    address: "oyur",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Gokul enterprises",
    address: "kadakkodu",
    area: "Kollam",
    state: "Kerala",
  },
  {
    name: "Bright furniture",
    address: "kadambanadu",
    area: "Pathanamthitta",
    state: "Kerala",
  },
  {
    name: "Tojo agencies",
    address: "Pathanamthitta",
    area: "Pathanamthitta",
    state: "Kerala",
  },
  {
    name: "HYSON FURNISH",
    address: "Thrissur",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "CHERKKOTTU FURNISH",
    address: "Thrissur",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "BISMI FURNISH",
    address: "Thrissur",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "PULLOKKARAN FURNITURE",
    address: "Chevoor",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "NEW PULLOKKARAN FURNITURE",
    address: "Chevoor",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "EMMANUVAL FURNITURE",
    address: "Perumbilissery",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "K.L.F FURNITURE",
    address: "Irinjalakkuda",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "PERUMBILLY FURNITURE",
    address: "Kodakara",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "MODERN FURNITURE",
    address: "Chalakudy",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "CITY BED CENTRE",
    address: "Chalakudy",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "R.K AGENCIES",
    address: "Aariyampadam",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "EYECEES FURNITURE",
    address: "Amalanagar",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "KAKATHOTTIL FURNITURE",
    address: "Kodali",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "RAJAH TIMBER COMPANY",
    address: "Chavakkad",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "RAJADHANI FURNITURE",
    address: "Kechery",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "GLOBE DECORATORS",
    address: "Kunnamkulam",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "RAJAH TIMBER COMPANY",
    address: "Kunnamkulam",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "HOME POINT",
    address: "Kunnamkulam",
    area: "Thrissur",
    state: "Kerala",
  },
  {
    name: "MODERN FURNISHINGS",
    address: "changaramkulam",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "KOKOS FURNISHINGS",
    address: "Edappal",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "THEYYAMPATTIL FURNITURE",
    address: "Puthanathani",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "FURNITURE WORLD",
    address: "Edarikode",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "MAK FRUNISHINGS",
    address: "Vengara",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "KURIKKAL KAIRALI GROUP",
    address: "Manjeri",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "TAJ MAHAL FURNITURE",
    address: "Makkaraparambu",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "KERALA FURNITURE",
    address: "Perinthalmanna",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "HIRA FURNITURE",
    address: "Kottakkal",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "UNITED COMMERCIAL AGENCY",
    address: "Palakkad",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "PREETHI MATTRESS AND CARPETS",
    address: "Palakkad",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "RUBI CURTAINS",
    address: "Palakkad",
    area: "Malppuram & Palakkad",
    state: "Kerala",
  },
  {
    name: "Home Cee Key Furniture",
    address: "Peringathur",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Village Home Decor",
    address: "Panoor",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Kalathil Furniture",
    address: "Kuthuparamba",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Alpha Bed Centre",
    address: "Kodiyeri",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Royal Furniture",
    address: "Pinarayi",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Furniture Home",
    address: "Chakkarakkal",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "New Cee Key Furniture",
    address: "Mutharipeedika",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Foam House",
    address: "Kannur",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "M A K S",
    address: "Kambil",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Royal Furniture",
    address: "Mayyil",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Alaska Interior",
    address: "Alakode",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "CAFCO TRADING CENTRE",
    address: "Near Mini Bypass, Meenchanda,",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "PREMIER AGENCIES",
    address: "Thadampattuthazam,",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "NEW MANIYARA FURNITURE",
    address: "ULLIYERI, CALICUT",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "CHERIKUNNUMMAL FURNITURE",
    address: "KOYILANDY.",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "K.H TRADING CONCERN",
    address: "MAIN ROAD,Ulliyeri",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "NEW ANASSERY FURNITURE",
    address: "Atholi",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "DORMITS",
    address: "Karanthur, Calicut",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "SAHODARA FURNITURE",
    address: "Near NIT, Kattangal",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "MALABAR FURNITURE",
    address: "Kuttikkttoor, Calicut",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Naseeb Furniture",
    address: "Treasury Building, Feroke",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "Hilite Furniture Village",
    address: "Iritty",
    area: "Calicut and Kannur",
    state: "Kerala",
  },
  {
    name: "FURNITURE & FURNISHING  MALL",
    concernPerson: "MR. ADITYA",
    phone: "7542027727",
    address: "GAYA A.P COLONY-823001",
    area: "Gaya",
    state: "Bihar",
  },
  {
    name: "SOFA IMPORIUM",
    concernPerson: "MR. SAIF",
    phone: "8507824150",
    address: "NEAR STATION ROAD-823001",
    area: "Gaya",
    state: "Bihar",
  },
  {
    name: "SOFA IMPORIUM",
    concernPerson: "MD. LATIF",
    phone: "9431271862",
    address: "NEAR GANDHI MAIDAN-823001",
    area: "Gaya",
    state: "Bihar",
  },
  {
    name: "KALYAN FURNITURE HOUSE",
    concernPerson: "JP KALYAN",
    phone: "9973454500",
    address: "NEAR BODHGAYA-824231",
    area: "Gaya",
    state: "Bihar",
  },
  {
    name: "I DECOR",
    concernPerson: "MR. RAHUL",
    phone: "6202017261",
    address: "BODHGAYA-824231",
    area: "Gaya",
    state: "Bihar",
  },
  {
    name: "GALAXY FURNITURE",
    concernPerson: "SURAJ",
    phone: "9934125486",
    address: "BY PASS CHOWK-824101",
    area: "Aurangabad",
    state: "Bihar",
  },
  {
    name: "NEW RAJSHEE",
    concernPerson: "MR. SANTOSH",
    phone: "7004840340",
    address: "NEAR THANA-824102",
    area: "Aurangabad",
    state: "Bihar",
  },
  {
    name: "HIND LETHER",
    concernPerson: "MR. KHURSHID",
    phone: "9504725128",
    address: "G B ROAD-824101",
    area: "Aurangabad",
    state: "Bihar",
  },
  {
    name: "ASHIYANA FURNISHING",
    concernPerson: "MR. AVINASH",
    phone: "8540807857",
    address: "BORING ROAD-800020",
    area: "Patna",
    state: "Bihar",
  },
  {
    name: "S M S FURNITURE",
    concernPerson: "MR. AJAY",
    phone: "7739821341",
    address: "RAJA BAZAR-800014",
    area: "Patna",
    state: "Bihar",
  },
  {
    name: "A ONE DECOR",
    concernPerson: "MR. CHANDAN",
    phone: "9430661688",
    address: "SHGUNA MORE-801503",
    area: "Patna",
    state: "Bihar",
  },
  {
    name: "FURNISHING HUB",
    concernPerson: "MR. GUNJAN",
    phone: "7301148851",
    address: "NEW DAKBUNGLOW-801105",
    area: "Patna",
    state: "Bihar",
  },
  {
    name: "MAHAVEER FURNISHING",
    concernPerson: "NANDU",
    phone: "9931580488",
    address: "NEW DAK BUNGLOW-801105",
    area: "Patna",
    state: "Bihar",
  },
  {
    name: "RAM KUMAR & COMPANY",
    concernPerson: "MR. VAIBHAV",
    phone: "8210064245",
    address: "ASHOK RAJPATH-800004",
    area: "Patna",
    state: "Bihar",
  },
  {
    name: "ANKUR FURNISHING",
    concernPerson: "MR. SANTOSH",
    phone: "9334331429",
    address: "S P VERMA-800001",
    area: "Patna",
    state: "Bihar",
  },
  {
    name: "A DECOR",
    concernPerson: "MR. HARSHIT",
    phone: "9263184850",
    address: "DAKBANGALA ROAD-801105",
    area: "Patna",
    state: "Bihar",
  },

  {
    name: "MOHAS LIFE STYLE",
    concernPerson: "MUKUL",
    phone: "9386732881",
    address: "B BHATACHARYA ROAD-801105",
    area: "Patna",
    state: "Bihar",
  },
  {
    name: "SHREE RAM FURNITURE",
    concernPerson: "MR. ANUJ",
    phone: "7004592931",
    address: "PALI ROAD-821307",
    area: "Dehri On Son",
    state: "Bihar",
  },
  {
    name: "HAPPY HOME FURNITURE",
    concernPerson: "MR. MUKESH",
    phone: "9905985880",
    address: "AKHARA ROAD-842001",
    area: "Muzzafar Pur",
    state: "Bihar",
  },
  {
    name: "IDEAL FURNITURE",
    concernPerson: "PRASANT",
    phone: "7542030843",
    address: "MUZAFFARPUR-842001",
    area: "Muzzafar Pur",
    state: "Bihar",
  },
  {
    name: "ASHA FURNITURE",
    concernPerson: "SOURABH",
    phone: "9431208888",
    address: "MUZAFFARPUR-842001",
    area: "Muzzafar Pur",
    state: "Bihar",
  },
  {
    name: "HOME DECOR",
    concernPerson: "MR. MANNA",
    phone: "9853470574",
    address: "DARBHANGA-846001",
    area: "Lahariya Sarai",
    state: "Bihar",
  },
  {
    name: "VIJAY UPHAR GHIRH",
    concernPerson: "VIJAY",
    phone: "9931429511",
    address: "EKTA CHOWK-82101",
    area: "Bhabhua",
    state: "Bihar",
  },
  {
    name: "A DECOR",
    concernPerson: "MR. HARSHIT",
    phone: "9263184850",
    address: "NEAR CRANE SCHOOL-823001",
    area: "Gaya",
    state: "Bihar",
  },
  {
    name: "DELCO FURNITURE",
    concernPerson: "MD. NAJJU",
    phone: "9835084915",
    address: "BEGUSARAI-851101",
    area: "Begusarai",
    state: "Bihar",
  },
  {
    name: "A TO Z FURNITURE",
    concernPerson: "MR. SANJEEV",
    phone: "9113735832",
    address: "KAGHZI MOHLLA-803101",
    area: "Biharsharif",
    state: "Bihar",
  },
  {
    name: "A TO Z FURNITURE",
    concernPerson: "MR. SANJEEV",
    phone: "9204361691",
    address: "NAWADA-805110",
    area: "Nawada",
    state: "Bihar",
  },
  {
    name: "SATYAM ENTERPRISES",
    concernPerson: "MR. CHANDAN",
    phone: "9431268513",
    address: "SUPAUL-852131",
    area: "Supaul",
    state: "Bihar",
  },
  {
    name: "SURAJ STEEL",
    concernPerson: "PANKAJ KUMAR",
    phone: "9431070400",
    address: "ARA-802301",
    area: "Ara",
    state: "Bihar",
  },
  {
    name: "KAMAL FURNITURE",
    concernPerson: "MR. CHANNU",
    phone: "9835827605",
    address: "NEAR V-MART-841301",
    area: "Chapara",
    state: "Bihar",
  },
  {
    name: "CHOTU SOFA MEKER",
    concernPerson: "MR. CHOTU",
    phone: "6200749470",
    address: "SARBODAY NAGAR-854302",
    area: "Purnea",
    state: "Bihar",
  },
  {
    name: "NADWANI HANDLOOM",
    concernPerson: "MR. NADWANI",
    phone: "9471627300",
    address: "AMLA TOLA ROAD-854105",
    area: "Katihar",
    state: "Bihar",
  },
  {
    name: "JAYBALA JI FURNITURE",
    concernPerson: "AMAR MODI",
    phone: "9934858972",
    address: "RAJA BAZAR-845401",
    area: "Motihari",
    state: "Bihar",
  },
  {
    name: "RANJAN FURNITURE",
    concernPerson: "MR. RANJAN",
    phone: "9631820669",
    address: "MUZAFFARPUR HIGHWAY-844101",
    area: "Hajipur",
    state: "Bihar",
  },
  {
    name: "RANJAN FURNITURE HOUSE",
    concernPerson: "MR. RANJAN KUMAR",
    phone: "9631820669",
    address: "MADHEPURA-852113",
    area: "Madhepur",
    state: "Bihar",
  },

  {
    name: "Revathy furniture",
    // concernPerson: "Rajalakshmi Muralidharan",
    phone: "8111924402",
    area: "Kollam",
    location:
      "https://www.google.com/maps/place/Revathy+Furniture/@8.8158822,76.8562822,11z/data=!4m9!1m2!2m1!1sRevathy+furniture+Tholicode,+Punalur+Pin+-+691333!3m5!1s0x3b0677c575c19b2d:0xb536c010084e19bb!8m2!3d9.0026752!4d76.9277375!15sCjFSZXZhdGh5IGZ1cm5pdHVyZSBUaG9saWNvZGUsIFB1bmFsdXIgUGluIC0gNjkxMzMzkgEPZnVybml0dXJlX3N0b3Jl",
    state: "Kerala",
    address: "Tholicodu, Punalur, Pin - 691333",
  },

  {
    name: "Revathy furniture",
    // concernPerson: "Rajalakshmi Muralidharan",
    phone: "8111924402",
    area: "Kollam",
    location:
      "https://www.google.com/maps/dir/28.6654464,77.2603904/Revathy+furniture+Agasthyacodu,+Anchal+Pin+-+691306/@18.5693177,68.0505472,5z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3b05d8acd5aa15cd:0xd7774742a14d2b1!2m2!1d76.9184047!2d8.9473957",
    state: "Kerala",
    address: "Agasthyacodu, Anchal, Pin - 691306",
  },

  {
    name: "Darvy Red Chilly Ernakulam",
    concernPerson: "Aji George",
    phone: "08075237894",
    area: "Ernakulam",
    location: "",
    state: "Kerala",
    address:
      "Redchilly Living, Near Velloorkunnam signal, M C Road, Muvattupuzha",
  },
  {
    name: "Darvy Red Chilly Ernakulam",
    concernPerson: "Darvy Jacob John",
    phone: "09349320856",
    area: "Ernakulam",
    location: "",
    state: "Kerala",
    address:
      "Josh Eagle Corporation, 34/138k, Vathakkatt building, By-pass road, Edapplly, Kochi, Ernakulam, Kerala - 682024",
  },
  {
    name: "Darvy Red Chilly Ernakulam",
    concernPerson: "Lisha",
    phone: "09349266584",
    area: "Ernakulam",
    location: "",
    state: "Kerala",
    address: "Bed n Bedsheets, Market Road, Thodupuzha",
  },
];

export const states = [
  "Delhi NCR",
  "Karnataka",
  "Maharashtra",
  "Chattisgarh",
  "Goa",
  "Jharkhand",
  "Punjab",
  "Rajasthan",
  "West Bengal",
  "Sikkim",
  "Kerala",
  "Bihar",
];
